import { SearchCriteria } from "../search-criteria";

export class GetCitiesCriteria extends SearchCriteria {
  public CountryId: number;

}
